import _ from 'lodash'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import appDisplay from 'scoreboard/components/app-display'
import EditLabel from 'scoreboard/components/designer/edit-label'
import { TestDeletableOption } from 'scoreboard/reports/common/edit-stack-menu'

const DeleteOption = TestDeletableOption.extend({
	_doDelete: function() {
		this.options.deleteStack()
	}
})


const EditRepeatByMenu = BootslideMenu.extend({
	/**
	 * @param options
	 * @param {function} options.setRepeatingColumn action for the set source
	 * option
	 * @param {function} options.deleteStack action for the delete option
	 * @param {ReportBreakdown} options.breakdown breakdown the breakdown model
	 * to use for label
	 * @param {string} options.defaultRepeatByLabel label to fill in editor if
	 * none is configured on the breakdown
	 * @param {function} options.testDeletable returns a message if the delete
	 * of the repeat by should be prevented for some reason
	 */
	initialize: function (options = {}) {
		this.setRepeatingColumn = options.setRepeatingColumn
		this.deleteStack = options.deleteStack
		this.breakdown = options.breakdown
		this.defaultRepeatByLabel = options.defaultRepeatByLabel
		this.testDeletable = options.testDeletable
		BootslideMenu.prototype.initialize.apply(this, arguments)
	},

	menu: function () {
		let target = []

		target.push({
			label: 'datasets.choose.columns.setRepeatingLabel',
			target: () => {
				const label = this.breakdown.get('repeatByLabel') ||
					this.defaultRepeatByLabel
				const editLabel = new EditLabel({
					header: 'datasets.choose.columns.setRepeatingLabel',
					inputLabel: 'datasets.choose.columns.repeatingLabel',
					label,
					default: !this.breakdown.get('repeatByLabel'),
					doneKey: 'common.done'
				})
				appDisplay.dialog(editLabel)
				editLabel.on('done', label => {
					if (!_.isNil(label) && !_.isNil(label.trim())) {
						this.breakdown.set('repeatByLabel', label.trim())
					} else {
						this.breakdown.unset('repeatByLabel')
					}
				})
			}
		})

		target.push({
			label: this.setRangeOrDataSourceLabel(),
			target: () => { this.setRepeatingColumn() }
		})

		target.push({
			label: 'common.delete',
			contentView: new DeleteOption({
				deleteStack: this.deleteStack,
				testDeletable: this.testDeletable
			})
		})

		return {
			label: 'report.designer.editRepeatBy',
			target,
			width: 180
		}
	},

	/**
	 * Returns the label for the option for either setting the range
	 * or setting the data source.
	 * If this.breakdown has the "range" attribute set, then the label is
	 * "Set Range".
	 * Otherwise, the label is "Set Data Source". #58958
	 */
	setRangeOrDataSourceLabel: function() {
		let range = this.breakdown.get('range')
		return range ? 'report.designer.setRange' :
			'report.designer.setDataSource'
	}
})

export default EditRepeatByMenu
EditRepeatByMenu.__filename__ = 'reports/common/edit-repeat-by-menu.js'
